import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/react';
import { ChevronDownIcon } from '@heroicons/react/20/solid';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import axios from 'axios';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { MdEmail } from 'react-icons/md';
import { useNavigate } from 'react-router-dom';
import { web_url } from '../../constant';


function StudentSignUpCheck() {
    useEffect(() => {
        localStorage.clear();
        sessionStorage.clear()
    }, [])

    const [language, setLanguage] = useState(() => {
        const languageNow = localStorage.getItem('language') ? localStorage.getItem('language') : 'English';
        return languageNow;
    })
    const { t, i18n } = useTranslation();
    useEffect(() => {
        switch (language) {
            case 'English':
                i18n.changeLanguage('en');
                break;
            case 'Sinhala':
                i18n.changeLanguage('si');
                break;
            case 'Tamil':
                i18n.changeLanguage('ta');
                break;
            default:
                i18n.changeLanguage('en');
                break;
        }
        localStorage.setItem('language', language);
    }, [language]);

    const navigate = useNavigate();
    const [open, setOpen] = useState(false);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const changeLanguage = (lang) => {
        i18n.changeLanguage(lang);
    };

    const [studentSignupDetails, setstudentSignupDetails] = useState(
        {
            email: '',
            sEmail: '',
            tEmail: '',
            tName: '',
            district: '',
            grade: '',
            class: '',
            school: '',
            invId: ''
        }
    )

    useEffect(() => {
        localStorage.removeItem('studentInvitation');
    }, [])

    const [errors, setErrors] = useState(
        {
            noEmail: false,
            invalidEmail: false,
        }
    )

    const [openError, setOpenError] = useState(false);

    const handleClickOpenError = (err) => {
        if (err.toLowerCase().includes('internal server error')) {
            setError(t('t93'));
        } else if (err.toLowerCase().includes('user found already')) {
            setError(t('t92'));
        } else if (err.toLowerCase().includes('email is already taken')) {
            setError(t('t92'));
        } else {
            setError(t('t94'));
        }
        setOpenError(true);
    };

    const handleCloseError = () => {
        localStorage.removeItem('/teachersignup1')
        setOpenError(false);
    };
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);

    const handleContinue = () => {
        localStorage.removeItem('studentInvitationByAdmin');

        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        const nameRegex = /^(?!.*script)[a-z0-9.]{7,}$/i;
        let newErrors = {};

        newErrors.noEmail = !studentSignupDetails.email;

        if ((studentSignupDetails.email) && !emailRegex.test(studentSignupDetails.email) && !nameRegex.test(studentSignupDetails.email)) {
            newErrors.invalidEmail = true;
        } else {
            newErrors.invalidEmail = false;
        }

        setErrors(newErrors);

        if (Object.values(newErrors).some((error) => error)) {
            return;
        }
        const config = {
            headers: {
                'Content-Type': 'multipart/form-data'
            },
        };

        const filterDetails = {
            receiverEmail: studentSignupDetails.email,
            invitationStatus: "PENDING"
        }

        // localStorage.setItem('studentsignup1', JSON.stringify(studentSignupDetails))


        setIsLoading(true);


        let form = new FormData();
        form.append('userEmail', studentSignupDetails.email);

        axios.post(`${web_url}/api/auth/register/students-check-availability`, form, config).then((resData) => {

            if (resData.data.inviationStatus === "invitation not found") {
                setIsLoading(false);
                localStorage.removeItem('userStatusDetails');
                localStorage.setItem('enteredEmail', studentSignupDetails.email)
                navigate('/studentpersonaldetails');
            } else if (resData.data.inviationStatus === "teacher invitation and admin invitation" || resData.data.inviationStatus === "teacher invitation only") {
                const [grade, division] = resData.data.details.assignedClass.split('-');
                const detailsObtained = {
                    sEmail: resData.data.details.studentEmail,
                    tEmail: resData.data.details.teacherEmail,
                    tName: resData.data.details.teacherFullName,
                    district: resData.data.details.district,
                    grade: grade,
                    class: division,
                    school: resData.data.details.school
                }
                // console.log('err 11');
                localStorage.setItem('userStatusDetails', JSON.stringify(detailsObtained));
                setIsLoading(false);
                localStorage.setItem('enteredEmail', studentSignupDetails.email)
                navigate('/studentpersonaldetails');
            } else if (resData.data.inviationStatus === "admin invitation only") {
                localStorage.setItem('studentInvitationByAdmin', "true");
                setIsLoading(false);
                localStorage.removeItem('userStatusDetails');
                localStorage.setItem('enteredEmail', studentSignupDetails.email)
                navigate('/studentpersonaldetails');
            }

        }).catch((err) => {
            console.log('err 13', err);
            if (err.response) {
                if (err.response.data.error) {
                    handleClickOpenError(err.response.data.error);
                } else if (err.response.data.message) {
                    handleClickOpenError(err.response.data.message);
                } else {
                    handleClickOpenError("An unknown error occured");
                }

            } else if (err.request) {
                const errorMessage = "No response from the server. Please check your network connection.";
            } else {
                const errorMessage = err.message;
            }
            // console.log('err 14');
            setIsLoading(false);
        })

    }

    useEffect(() => {
        localStorage.removeItem('userStatusDetails');
        localStorage.removeItem('studentsignup1');
        localStorage.removeItem('enteredEmail')
    }, [])

    return (
        <div className={`${i18n.language === "en" ? "font-urban" : (i18n.language === "si" ? "font-noto" : "font-mukta")} bg-bgImg md:bg-bglarge  bg-no-repeat bg-cover h-screen w-screen flex flex-col justify-center pl-[30px] pr-[30px] md:items-center`}>
            <Menu as="div" className="absolute top-0 right-0 m-[10px] text-left items-right">
                <div>
                    <MenuButton className="inline-flex w-full justify-center gap-x-1.5 rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-black hover:bg-gray-50">
                        {language === "Sinhala" ? "සිංහල" : (language === "Tamil" ? "தமிழ்" : language)}
                        <ChevronDownIcon aria-hidden="true" className="-mr-1 size-5 text-gray-400" />
                    </MenuButton>
                </div>

                <MenuItems
                    transition
                    className="absolute right-0 z-10 mt-2 w-56 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black/5 transition focus:outline-none data-[closed]:scale-95 data-[closed]:transform data-[closed]:opacity-0 data-[enter]:duration-100 data-[leave]:duration-75 data-[enter]:ease-out data-[leave]:ease-in"
                >
                    <div className="py-1">
                        <MenuItem>
                            <button
                                className="text-left w-full block px-4 py-2 text-sm text-gray-700 focus:bg-gray-100 focus:text-gray-900 focus:outline-none"
                                onClick={() => {
                                    setLanguage("English");
                                    changeLanguage('en')
                                }}
                            >
                                English
                            </button>
                        </MenuItem>
                        <MenuItem>
                            <button
                                className="text-left w-full block px-4 py-2 text-sm text-gray-700 focus:bg-gray-100 focus:text-gray-900 focus:outline-none"
                                onClick={() => {
                                    setLanguage("Sinhala");
                                    changeLanguage('si')
                                }}
                            >
                                සිංහල
                            </button>
                        </MenuItem>
                        <MenuItem>
                            <button
                                className="text-left w-full block px-4 py-2 text-sm text-gray-700 focus:bg-gray-100 focus:text-gray-900 focus:outline-none"
                                onClick={() => {
                                    setLanguage("Tamil");
                                    changeLanguage('ta')
                                }}
                            >
                                தமிழ்
                            </button>
                        </MenuItem>
                    </div>
                </MenuItems>
            </Menu>
            <div className='flex flex-col justify-center h-full sm:w-full sm:w-full md:w-[400px] lg:w-[500px] xl:w-[500px]  2xl:w-[500px]'>
                <img src="/images/logo.svg" className="h-[100px] md:h-[130px] xl:h-[120px] 2xl:h-[130px]" alt='logo' />
                <p className={`text-[#1E2533] text-center font-[600] leading-[27px] xl:leading-[30px] ${i18n.language === "en" ? "text-[21px] md:text-[23px] lg:text-[27px] xl:text-[27px] 2xl:text-[28px]" : (i18n.language === "si" ? "text-[17px] md:text-[22px] lg:text-[19px] xl:text-[22px] 2xl:text-[18px]" : "text-[16px] md:text-[19px] lg:text-[17px] xl:text-[20px] 2xl:text-[18px]")} mt-[20px]`}>{t('t358')}</p>
                {/* <p className='mt-[10px] text-[16px] font-bold text-[#FDC50C]'>{t('t358')}</p> */}

                {
                    isLoading ?
                        <div className="items-center justify-center flex pt-[30px]">
                            <div className='w-10 h-10 border-2 border-t-transparent border-[#FFA803] rounded-full animate-spin'></div>
                        </div>
                        :
                        <>
                            <div className="items-center mt-[20px] flex rounded-md bg-[#F1F6FB] px-[10px] h-[60px] md:h-[70px] xl:h-[60px] 2xl:h-[70px] outline outline-1 -outline-offset-1 outline-gray-300 focus-within:outline focus-within:outline-2 focus-within:-outline-offset-2 focus-within:outline-gray-400">
                                <MdEmail size="24px" color="#8189B0" />
                                <input type="text" name="email" className={`ml-[10px] w-full bg-[#F1F6FB] text-[13px] md:text-[15px] 2xl:text-[20px] text-gray-900  ${i18n.language === "en" ? "placeholder:text-[15px] md:placeholder:text-[19px] lg:placeholder:text-[20px] xl:placeholder:text-[15px] 2xl:placeholder:text-[17px]" : (i18n.language === "si" ? "placeholder:text-[12x] md:placeholder:text-[16px] lg:placeholder:text-[16px] xl:placeholder:text-[13px] 2xl:placeholder:text-[15px]" : "placeholder:text-[12px] md:placeholder:text-[15px] lg:placeholder:text-[16px] xl:placeholder:text-[12px] 2xl:placeholder:text-[15px]")} placeholder:text-[#8189B0] focus:outline focus:outline-0`} placeholder={t('t441')}
                                    // <input type="text" name="email" className="ml-[10px] w-full bg-[#F1F6FB] text-[15px] text-gray-900 placeholder:text-[#8189B0] focus:outline focus:outline-0" placeholder={t('t14')}
                                    onChange={(e) => {
                                        setstudentSignupDetails((prevState) => ({
                                            ...prevState, email: e.target.value.toLowerCase()
                                        }))
                                    }}
                                />
                            </div>
                            {errors.noEmail &&
                                // <p className='text-[#ff0000] text-[12px] mt-[5px]'>{t('t15')}</p>
                                <p className='text-[#ff0000] text-[12px] mt-[5px]'>{t('t442')}</p>
                            }
                            {errors.invalidEmail &&
                                <>
                                    <p className={`text-[#ff0000] ${i18n.language === "en" ? "text-[12px]" : "text-[10px]"} mt-[5px]`}>{t('t443')}</p>
                                    <p className={`text-[#ff0000] ${i18n.language === "en" ? "text-[12px]" : "text-[10px]"} mt-[5px]`}>{t('t444')}</p>
                                    <p className={`text-[#ff0000] ${i18n.language === "en" ? "text-[12px]" : "text-[10px]"} mt-[5px]`}>{t('t445')}</p>
                                </>
                            }
                        </>
                }

                <button onClick={handleContinue} className={`text-white ${i18n.language === "en" ? "text-[18px] md:text-[18px] xl:text-[17px] 2xl:text-[22px]" : (i18n.language === "si" ? "text-[16px] md:text-[14px] xl:text-[14px] 2xl:text-[19px]" : "text-[16px] md:text-[14px] xl:text-[13px] 2xl:text-[18px]")} mt-[20px] rounded-lg pt-[10px] pb-[10px] w-full hover:bg-opacity-80 bg-[#EFAE03] font-bold `}>{t('t7')}</button>
                <p className={`text-[#333333] ${i18n.language === "en" ? "text-[14px] md:text-[18px] xl:text-[15px] 2xl:text-[16px]" : (i18n.language === "si" ? "text-[12px] md:text-[14px] xl:text-[14px] 2xl:text-[14px]" : "text-[11px] md:text-[14px] xl:text-[12px] 2xl:text-[14px]")} text-center mt-[20px] mb-[20px]`}>{t('t24')} <span onClick={() => (navigate('/loginas'))} className={`font-[700] text-[#333333] hover:cursor-pointer underline`}>{t('t25')}</span></p>

                <Dialog
                    open={open}
                    onClose={handleClose}
                    aria-labelledby="custom-dialog-title"
                    aria-describedby="custom-dialog-description"
                    className="backdrop-blur-sm"
                >
                    <DialogTitle
                        id="custom-dialog-title"
                        className="text-2xl font-bold text-gray-800 border-b border-gray-300 pb-2"
                    >
                        ⚠️  {t('t48')}
                    </DialogTitle>
                    <DialogContent className="bg-gray-50">
                        <DialogContentText
                            id="custom-dialog-description"
                            className="text-gray-600 text-md mt-2"
                        >
                            {t('t10')}
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions className="px-4 py-2">
                        <Button
                            onClick={handleClose}
                            className="bg-[#F2AC0E] text-white px-4 py-2 rounded-md"
                            style={{ backgroundColor: '#F2AC0E', color: 'white', fontWeight: 'bold' }}
                        >
                            {t('t13')}
                        </Button>
                    </DialogActions>
                </Dialog>

                <Dialog
                    open={openError}
                    onClose={(event, reason) => {
                        if (reason !== "backdropClick") {
                            handleCloseError(); // Allow closing only for other reasons
                        }
                    }}
                    aria-labelledby="custom-dialog-title"
                    aria-describedby="custom-dialog-description"
                    className="backdrop-blur-sm"
                >
                    <DialogTitle
                        id="custom-dialog-title"
                        className="text-2xl font-bold text-gray-800 border-b border-gray-300 pb-2"
                    >
                        {t('t95')}
                    </DialogTitle>
                    <DialogContent className="bg-gray-50">
                        <DialogContentText
                            id="custom-dialog-description"
                            className="text-gray-600 text-md mt-2"
                        >
                            {error}
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions className="px-4 py-2">
                        <Button
                            onClick={handleCloseError}
                            className="bg-[#F2AC0E] text-white px-4 py-2 rounded-md"
                            style={{ backgroundColor: '#F2AC0E', color: 'white', fontWeight: 'bold' }}
                        >
                            {t('t96')}
                        </Button>
                    </DialogActions>
                </Dialog>
            </div>
        </div>
    );
}

export default StudentSignUpCheck;